import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "container d-flex align-center ga-1 ga-lg-2"
}
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = {
  key: 0,
  class: "menu-list"
}
const _hoisted_4 = { class: "options-list d-flex align-center" }
const _hoisted_5 = {
  key: 0,
  class: "options-list-item"
}
const _hoisted_6 = {
  key: 1,
  class: "options-list-item"
}
const _hoisted_7 = {
  key: 2,
  class: "options-list-item"
}
const _hoisted_8 = {
  key: 3,
  class: "options-list-item"
}
const _hoisted_9 = {
  key: 4,
  class: "options-list-btn"
}
const _hoisted_10 = {
  key: 5,
  class: "options-list-btn"
}

import { useI18n } from "vue-i18n";
import { storeToRefs } from "pinia";
import { useDisplay } from "vuetify";
import { useRoute } from "vue-router";

import { useAccounts, useAppStore } from "@/stores";

import {
  ROUTE_ABOUT,
  ROUTE_CREATE_TOKEN,
  ROUTE_HOME,
  ROUTE_INVITE,
  SETTINGS,
} from "@/utils/constants";

import ActiveAccountBtn from "@/components/Account/ActiveAccountBtn.vue";
import WalletConnectBtn from "@/components/WalletConnect/WalletConnectBtn.vue";
import ToggleDarkMode from "@/components/Header/ToggleDarkMode.vue";
import NetworkSelector from "@/components/Header/NetworkSelector.vue";
import CurrencySelector from "@/components/Header/CurrencySelector.vue";
import LanguageSelector from "@/components/Header/LanguageSelector.vue";
import AppLogo from "@/components/Common/AppLogo.vue";
import TopBarSkeleton from "@/components/Skeletons/TopBarSkeleton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const { t } = useI18n();
const { isSdkInitialized, isMobile } = storeToRefs(useAppStore());
const { activeAccount } = storeToRefs(useAccounts());
const { mdAndDown } = useDisplay();

const menuItems = [
  {
    routeName: ROUTE_HOME,
    text: t("common.coinList"),
  },
  {
    routeName: ROUTE_CREATE_TOKEN,
    text: t("blocks.appHeader.createToken"),
  },
  {
    routeName: ROUTE_INVITE,
    text: t("blocks.appHeader.invite"),
  },
  {
    routeName: ROUTE_ABOUT,
    text: t("blocks.appHeader.about"),
  },
];

const route = useRoute();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    class: "bcl-app-header px-2 px-sm-3 px-md-4",
    location: "top",
    app: "",
    fixed: ""
  }, {
    default: _withCtx(() => [
      (!_unref(isSdkInitialized))
        ? (_openBlock(), _createBlock(TopBarSkeleton, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(AppLogo, {
                class: "logo-btn mr-md-3 mr-lg-6",
                linked: ""
              }),
              (!_unref(isMobile))
                ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuItems, ({ routeName, text }, index) => {
                      return _createElementVNode("li", {
                        key: index,
                        class: "menu-list-item"
                      }, [
                        _createVNode(_component_RouterLink, {
                          to: { name: routeName },
                          class: _normalizeClass(["px-1 px-md-2 px-lg-3 bcl-app-menu-link", [_unref(route).name === routeName ? 'text-primary' : '']]),
                          exact: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(text), 1)
                          ]),
                          _: 2
                        }, 1032, ["to", "class"])
                      ])
                    }), 64))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_v_spacer),
            _createElementVNode("div", _hoisted_4, [
              (!_unref(isMobile))
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(NetworkSelector)
                  ]))
                : _createCommentVNode("", true),
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(ToggleDarkMode)
                  ]))
                : _createCommentVNode("", true),
              (!_unref(isMobile))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(CurrencySelector)
                  ]))
                : _createCommentVNode("", true),
              (_unref(SETTINGS).languages.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(LanguageSelector)
                  ]))
                : _createCommentVNode("", true),
              (_unref(activeAccount))
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(ActiveAccountBtn)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(WalletConnectBtn, {
                      size: "large",
                      outlined: "",
                      "hide-label": _unref(mdAndDown)
                    }, null, 8, ["hide-label"])
                  ]))
            ])
          ]))
    ]),
    _: 1
  }))
}
}

})